import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, Link } from "react-router-dom";
import { loggedInUser } from "../Auth/Auth_Slice";
import { fetchLoggedInUserOrderByIdAsync } from "./userSlice";
import { fetchByIdOrder } from "./userSlice";
import { isLoadingUserSlice } from "./userSlice"
import LoadingState from "../../components/Common/LoadingState"
import { paymentLabels } from "../../Pages/OrderStatusPage";
const moment = require('moment');

const formatNumber = (number) => {
  if (number) {
    let x = number;
    x = x.toString();
    let lastThree = x.substring(x.length - 3);
    let otherNumbers = x.substring(0, x.length - 3);
    if (otherNumbers !== '')
      lastThree = ',' + lastThree;
    let res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
    return res;
  }
}

function Order() {
  const user = useSelector(loggedInUser);
  const loading = useSelector(isLoadingUserSlice);
  const params = useParams();
  const dispatch = useDispatch();
  const orderById = useSelector(fetchByIdOrder);

  useEffect(() => {
    if (user !== null && params.id) {
      dispatch(fetchLoggedInUserOrderByIdAsync(params.id))
    }
  }, [params.id, user, dispatch])

  return (loading ?
    (<div className="w-full flex justify-center px-2 md:px-4 py-5">
      <LoadingState />
    </div>) :
    orderById !== null && (
      <div className="w-full bg-white">
        <div className="lg:max-w-7xl px-2 sm:px-6 lg:px-8 pt-6 pb-10 mx-auto">
          <div className="inline-block min-w-full rounded-lg overflow-hidden py-5">

            <div className="flex flex-col sm:flex-row justify-between mb-6 items-start sm:items-center px-2">
              <h2 className="text-xl sm:text-2xl text-gray-900 font-bold uppercase tracking-tight">
                Order #{orderById?.orderId}
              </h2>
              <div className="text-[11px] sm:text-sm text-gray-500 mt-2 sm:mt-0 flex flex-col items-start sm:items-end italic">
                <span>Placed: {moment(orderById?.createdAt).format('Do MMM YYYY, h:mm A')}</span>
                <span>Updated: {moment(orderById?.updatedAt).format('Do MMM YYYY, h:mm A')}</span>
              </div>
            </div>

            <div className="space-y-6">
              {/* Delivery Address Card */}
              <div className="bg-gray-50 border border-gray-200 rounded-xl p-4 sm:p-6">
                <h3 className="font-bold text-gray-900 text-sm sm:text-base uppercase mb-3">Delivery Address</h3>
                <div className="text-gray-600 text-sm space-y-1">
                  <span className="block font-medium text-gray-800 uppercase">{orderById?.shippingAddress.customerName}</span>
                  <span className="block uppercase">
                    {`${orderById?.shippingAddress.customerAddress}, ${orderById?.shippingAddress.customerCity}, ${orderById?.shippingAddress.customerState} - ${orderById?.shippingAddress.customerPincode}`}
                  </span>
                  <span className="block font-medium">Phone: {orderById?.shippingAddress.customerPhoneNo}</span>
                </div>
              </div>

              {orderById.items.map((item, index) => (
                <div key={item?.name + index} className="bg-white border border-gray-200 rounded-xl overflow-hidden">
                  {index > 0 && <p className="px-6 pt-4 text-xs font-bold text-indigo-600 uppercase">Other items in this order</p>}

                  <div className="p-4 sm:p-8 lg:grid lg:grid-cols-12 lg:gap-x-8">
                    {/* Product Info */}
                    <div className="flex items-start sm:items-center lg:col-span-6">
                      <div className="flex-shrink-0 w-24 h-24 sm:w-40 sm:h-40 rounded-lg overflow-hidden border border-gray-100">
                        <img src={item.images[0]} alt={item.name} className="w-full h-full object-contain" />
                      </div>
                      <div className="ml-4 sm:ml-6 flex-1">
                        <Link to={`/${item.href}/${item.productId}`} className="text-sm sm:text-base font-bold text-gray-900 hover:text-indigo-600">
                          {item.name}
                        </Link>
                        <div className="mt-2 text-xs sm:text-sm text-gray-500 space-y-1">
                          <p className="text-gray-900 font-bold text-base">₹{formatNumber(item.price)}</p>
                          <p>Quantity: <span className="text-gray-900 font-medium">{item?.quantity}</span></p>
                          <p className="capitalize">Color: <span className="text-gray-900 font-medium">{item?.color}</span></p>
                        </div>
                      </div>
                    </div>

                    {/* Order Status Stepper */}
                    <div className="mt-10 lg:mt-0 lg:col-span-6">
                      <div className="px-2">
                        <div className="bg-gray-200 h-1.5 rounded-full flex relative">
                          {/* Progress Line */}
                          <div
                            className="h-full bg-green-600 rounded-full transition-all duration-500"
                            style={{ width: `${orderById?.status === 1 ? '20%' : orderById?.status === 2 ? '35%' : orderById?.status === 3 ? '70%' : '100%'}` }}
                          />
                          <div className="absolute w-full flex justify-between -top-1">
                            {[1, 2, 3, 4].map((s) => (
                              <div key={s} className={`w-3.5 h-3.5 rounded-full border-2 border-white ${orderById?.status >= s ? "bg-green-600" : "bg-gray-300"}`} />
                            ))}
                          </div>
                        </div>
                        <div className="flex justify-between mt-4 text-[10px] sm:text-xs font-bold uppercase tracking-tighter sm:tracking-normal text-gray-400">
                          <span className={orderById?.status >= 1 ? "text-green-600" : ""}>Placed</span>
                          <span className={orderById?.status >= 2 ? "text-green-600" : ""}>Processing</span>
                          <span className={orderById?.status >= 3 ? "text-green-600" : ""}>Shipped</span>
                          <span className={orderById?.status >= 4 ? "text-green-600" : ""}>Delivered</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}

              {/* Billing Summary */}
              <div className="bg-gray-50 border border-gray-200 rounded-xl p-6 sm:p-8">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
                  <div className="md:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-6">
                    <div>
                      <dt className="font-bold text-gray-900 text-sm uppercase">Billing Address</dt>
                      <dd className="mt-3 text-gray-600 text-sm space-y-1">
                        <span className="block uppercase">{orderById?.shippingAddress.customerName}</span>
                        <span className="block text-xs uppercase">{orderById?.shippingAddress.customerAddress}, {orderById?.shippingAddress.customerCity}</span>
                        <span className="block">Phone: {orderById?.shippingAddress.customerPhoneNo}</span>
                      </dd>
                    </div>
                    <div>
                      <dt className="font-bold text-gray-900 text-sm uppercase">Payment Info</dt>
                      <dd className="mt-3 text-gray-900 text-sm uppercase">
                        {paymentLabels[orderById?.paymentMethod] || orderById.paymentMethod}
                      </dd>
                    </div>
                  </div>

                  <div className="md:col-span-5 border-t md:border-t-0 md:border-l border-gray-200 pt-6 md:pt-0 md:pl-8">
                    <dl className="space-y-4 text-sm">
                      <div className="flex justify-between text-gray-600">
                        <dt>Subtotal</dt>
                        <dd className="font-medium text-gray-900">₹{formatNumber(orderById.grandTotal)}</dd>
                      </div>
                      <div className="flex justify-between text-gray-600">
                        <dt>Shipping</dt>
                        <dd className="text-green-600 font-bold uppercase text-xs">Free</dd>
                      </div>
                      <div className="flex justify-between border-t border-gray-200 pt-4">
                        <dt className="text-base font-bold text-gray-900">Grand Total</dt>
                        <dd className="text-base font-bold text-indigo-600">₹{formatNumber(orderById.grandTotal)}</dd>
                      </div>
                    </dl>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  )
}

export default Order;